import { z } from 'zod';

const literalPattern = z.string().trim().min(1, '請輸入關鍵字').max(128).refine(
  value => !/[\s\x00-\x1f\x7f]/.test(value),
  '關鍵字不可包含空白或控制字元',
);

export const MemberEmailBlacklistRuleSchema = z.object({
  scope: z.enum(['brand', 'global']),
  targetBrand: z.string().optional(),
  pattern: literalPattern,
  description: z.string().max(255).optional(),
  enabled: z.boolean(),
}).superRefine((value, context) => {
  if (value.scope === 'brand' && !value.targetBrand) context.addIssue({ code: z.ZodIssueCode.custom, path: ['targetBrand'], message: '請選擇目標品牌' });
});

export type MemberEmailBlacklistRuleDTO = z.infer<typeof MemberEmailBlacklistRuleSchema>;
